import { h, Component } from 'preact';
import { observer } from 'mobx-preact';

import style from './style.css';
import util from '../../lib/util';

@observer
class Json extends Component {
    render() {
        const {
            name,
            value,
            help,
        } = this.props;

        return (
            <div>
                <code class={style.code}>{JSON.stringify(value, null, 4)}</code>

                <small id={`${name}Help`} class='form-text text-muted'>
                    <small class='float-right text-info ml-2'>"{util.getType(value)}"</small>
                    <small class='float-right'>"{name}"</small>
                    {help}
                </small>
            </div>
        );
    }
}

export default Json;



// WEBPACK FOOTER //
// ./components/form/json.js